/* eslint-disable react/prop-types */

function Card({ name, count, percent, icon, className }) {
  const isPositive = Number(percent) >= 0;

  return (
    <div
      className={` w-[270px] bg-cblack3 shadow-md rounded-lg p-4 border-2 border-cblack5 flex items-center gap-4 ${className}`}
    >
      <div className="bg-cblack7 rounded-md text-2xl p-4 flex items-center justify-center">
        {icon}
      </div>
      <div className="flex flex-col">
        <h3 className="text-sm font-normal text-color5">{name}</h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xl font-bold">{count !== undefined && count !== null ? count : "00"}</span>
          {percent !== undefined && percent !== null && (
            <span className={`text-xs font-semibold ${isPositive ? "text-cgreen" : "text-cred"}`}>
              {isPositive ? `+${percent}%` : `${percent}%`}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
export default Card;
